import * as $ from 'jquery';

// Based on the actual Query that Canvas uses see:
// https://github.com/instructure/canvas-lms/tree/master/ui/features/discussion_topics_post/graphql
const GetDiscussionQuery = `
query GetDiscussionQuery(
    $discussionID: ID!
) {
    legacyNode(_id: $discussionID, type: Discussion) {
        ...Discussion
    }
}
fragment Discussion on Discussion {
    isAnnouncement
    discussionType
    permissions {
        ...DiscussionPermissions
    }
}
fragment DiscussionPermissions on DiscussionPermissions {
    update
}
`;

export interface IDDiscussionInfo {
    isAnnouncement: boolean;
    discussionType: string;
    permissions: {
        update: boolean;
    };
}

/**
 * Fetches Discussion metadata and permissions from Canvas GraphQL API
 */
export function getDiscussionInfo(discussionId: string, jq: JQueryStatic = $): Promise<Partial<IDDiscussionInfo>> {
    return new Promise<IDDiscussionInfo>((resolve, reject) => {
        jq.ajax({
            'contentType': 'application/json',
            'data': JSON.stringify({
                'query': GetDiscussionQuery,
                'variables': {
                    'discussionID': discussionId
                }
            }),
            'error': reject,
            'headers': {
                'X-CSRF-Token': decodeCSRF(document.cookie)
            },
            'success': ({ data = {} }) => resolve(data.legacyNode ? data.legacyNode : {}),
            'type': 'POST',
            'url': '/api/graphql'
        });
    });
}

/**
 * Decodes CSRF token from cookies if available
 */
export function decodeCSRF(cookie: string): string | undefined {
    const matches = cookie.match('(^|;) *_csrf_token=([^;]*)');
    return matches ? decodeURIComponent(matches[2]) : undefined;
}
